import React from 'react';
import DropdownTreeSelect from 'react-dropdown-tree-select';
import isEqual from 'lodash/isEqual';
import { Form } from 'react-bootstrap';

const AwpTreeSelect = ({ data, onChange, ...otherProps }) => {
  const onChangeTemp = (currentNode, selectedNodes) => {
    onChange(currentNode, selectedNodes);
  };

  return (
    <>
      <Form.Label>
        <b>{otherProps.label}</b>
      </Form.Label>
      <DropdownTreeSelect data={data && data.value !== '' ? data : []} onChange={onChangeTemp} {...otherProps} />
    </>
  );
};

export default React.memo(AwpTreeSelect, (prevProps, nextProps) => {
  // Only re-render when the data prop changes
  return isEqual(prevProps.data, nextProps.data);
});
